import { render } from "./TerminateModal.vue?vue&type=template&id=47e3288e"
import script from "./TerminateModal.vue?vue&type=script&lang=js"
export * from "./TerminateModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__